import { cva } from 'class-variance-authority';

export const devToolsStatusDotVariants = cva(
  'h-[5px] w-[5px] flex-shrink-0 rounded-full',
  {
    variants: {
      status: {
        healthy: 'bg-emerald-400',
        warning: 'bg-amber-400',
        error: 'bg-red-400 animate-pulse',
        idle: 'bg-zinc-400',
      },
    },
    defaultVariants: { status: 'idle' },
  }
);
